<template>
  <div style="min-height: 768px; padding-top: 70px">
    <h2 class="text-center mt-4">Aprende nuevas habilidades</h2>
    <sync-loader
      :color="color"
      v-if="spiner"
      style="margin-left: 47%; padding-top: 15%; padding-bottom: 5%"
    ></sync-loader>
    <section class="section section-lg pt-lg-0 pt-5" v-else>
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-12">
            <div class="row row-grid" v-if="cours.length > 0">
              <div class="col-lg-4" v-for="courses in cours">
                <div
                  class="card card-lift--hover shadow border-0 mt-3 mb-4"
                  style="border-radius: 10px"
                  v-if="courses.courses"
                >
                  <div
                    class="card-body"
                    style="border-top: 2.5px solid #5e72e4; border-radius: 10px"
                  >
                    <img
                      class="img-fluid mb-2"
                      :src="courses.courses.data.imageUrl"
                    />
                    <div style="height: 130px">
                      <h6
                        class="text-primary"
                        v-text="courses.courses.name"
                      ></h6>
                      <p
                        class="description mt-3"
                        v-text="
                          courses.courses.description.substring(0, 120) + '..'
                        "
                      ></p>
                    </div>
                  </div>
                  <div class="card-footer">
                    <!--<a class="btn btn-primary text-white" style="border-radius: 30px" >Próximamente</a>-->
                    <a
                      class="btn btn-primary text-white"
                      style="border-radius: 30px"
                      @click.prevent="
                        courseDetail(courses, courses.id, courses.courses.name)
                      "
                      >Comienza Ahora</a
                    >
                  </div>
                </div>
              </div>
            </div>
            <div v-else style="text-align: center">
              <img src="/image/resource/pronto-01.png" width="500px" />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { mapState } from "vuex";
import axios from "axios";
import SyncLoader from "vue-spinner/src/PulseLoader.vue";
export default {
  name: "getCourses",
  components: {
    SyncLoader,
  },
  created() {
    this.getAllCourses();
  },
  data() {
    return {
      cours: [],
      proyect_id: process.env.VUE_APP_PROYECT_ID,
      spiner: false,
      color: "#9A32D6",
      category_id: this.$route.params.id,
    };
  },
  computed: {
    ...mapState,
  },
  methods: {
    getAllCourses: function () {
      this.spiner = true;
      this.$store
        .dispatch("course/getAllCourses", {
          category_id: this.category_id,
          proyect_id: this.proyect_id,
        })
        .then((response) => {
          this.cours = response;
          this.spiner = false;
        })
        .catch((error) => {
          console.log(error);
          this.spiner = false;
        });
    },

    courseDetail: function (courses, id, name) {
      var slug = "";
      // Change to lower case
      var titleLower = name.toLowerCase();
      // Letter "e"
      slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, "e");
      // Letter "a"
      slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, "a");
      // Letter "o"
      slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, "o");
      // Letter "u"
      slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, "u");
      // Letter "d"
      slug = slug.replace(/đ/gi, "d");
      // Trim the last whitespace
      slug = slug.replace(/\s*$/g, "");
      // Change whitespace to "-"
      slug = slug.replace(/\s+/g, "-");

      /* localStorage.setItem('e_x_c', (JSON.stringify(courses.courses)));*/
      this.$router.push("/courses/" + id + "/" + slug);
    },
  },
};
</script>